import { TSign } from 'src/interfaces/evaluation';

/**
 * Will return is the evaluation is complete.
 * An evaluation is complete when all signs are provided
 *
 * @param {TSign[]} signs
 */
export const isEvaluationComplete = (signs: TSign[]) =>
    signs.length > 0 && signs.every((sign) => sign.sign);
